import * as ambassadorWixBillingTaxV1TaxSettings from './billing-tax-v1-tax-settings-tax-settings.http.js';
import * as ambassadorWixBillingTaxV1TaxSettingsTypes from './billing-tax-v1-tax-settings-tax-settings.types.js';
import * as ambassadorWixBillingTaxV1TaxSettingsUniversalTypes from './billing-tax-v1-tax-settings-tax-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getTaxSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBillingTaxV1TaxSettingsUniversalTypes.GetTaxSettingsRequest,
  ambassadorWixBillingTaxV1TaxSettingsTypes.GetTaxSettingsRequest,
  ambassadorWixBillingTaxV1TaxSettingsUniversalTypes.GetTaxSettingsResponse,
  ambassadorWixBillingTaxV1TaxSettingsTypes.GetTaxSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingTaxV1TaxSettings.getTaxSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tax-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function upsertTaxSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingTaxV1TaxSettingsUniversalTypes.UpsertTaxSettingsRequest,
  ambassadorWixBillingTaxV1TaxSettingsTypes.UpsertTaxSettingsRequest,
  ambassadorWixBillingTaxV1TaxSettingsUniversalTypes.UpsertTaxSettingsResponse,
  ambassadorWixBillingTaxV1TaxSettingsTypes.UpsertTaxSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingTaxV1TaxSettings.upsertTaxSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tax-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TaxSettings as TaxSettingsOriginal,
  GetTaxSettingsRequest as GetTaxSettingsRequestOriginal,
  GetTaxSettingsResponse as GetTaxSettingsResponseOriginal,
  UpsertTaxSettingsRequest as UpsertTaxSettingsRequestOriginal,
  UpsertTaxSettingsResponse as UpsertTaxSettingsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './billing-tax-v1-tax-settings-tax-settings.types.js';
